module.exports = __webpack_public_path__ + "static/media/logo-travail.956fbef7.svg";